export default __webpack_public_path__ + "static/media/only_me_cut.2c9e12b1.png";